import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const SaleBanner = () => {
  return (
    <section className="py-12 md:py-16" id="sale">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative w-full h-[400px] md:h-[480px] rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=1920&q=80"
            alt="Sonbahar trekking"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

          <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-16">
            <span
              className="text-[#C8D843] text-sm font-semibold tracking-[0.15em] uppercase mb-3"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              2026 Sonbahar
            </span>
            <h2
              className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 uppercase tracking-tight leading-tight"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              ERKEN REZERVASYON<br />FIRSATLARI BAŞLADI
            </h2>
            <p className="text-white/90 text-base md:text-lg mb-6 max-w-lg">
              Tüm turlarda %20'ye varan indirim fırsatını kaçırmayın
            </p>
            <Link
              to="/turlar"
              data-testid="sale-cta-tours"
              className="inline-flex items-center gap-2 bg-[#C8D843] text-[#1B1B1B] font-semibold px-7 py-3.5 rounded-full text-sm hover:bg-[#b8c83a] transition-all duration-300 hover:scale-105 w-fit"
            >
              Tüm Turları Gör
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaleBanner;
